import { Injectable } from '@angular/core';
import { firstValueFrom, Observable } from 'rxjs';
import { CountryModel, CountryResourceService } from '../vn-api';

@Injectable({
  providedIn: 'root'
})
export class HxCountryService {
  constructor(
    private countryResourceService: CountryResourceService,
  ) {
  }

  getCountries(): Promise<CountryModel[]> {
    return firstValueFrom(this.countryResourceService.getCountries());
  }

  getCountryById(id: number): Promise<CountryModel> {
    return firstValueFrom(this.countryResourceService.getCountryById(id));
  }

  getCountryByCityId(id: number): Promise<CountryModel> {
    return firstValueFrom(this.countryResourceService.getCountryByCityId(id));
  }

  getMyCountries(): Observable<CountryModel[]> {
    return this.countryResourceService.getMyCountries();
  }
}
